import { IObservable, Subject } from '~/rage/utils';
import { IRestrictionsService } from './restrictionsServiceTypes';

export class RestrictionsServiceStub implements IRestrictionsService {
	private muteExpiresAt = new Subject<number | null>(
		Date.now() + 20 * 60 * 1000,
	);
	private playerBanned = new Subject<boolean>(true);
	private playerKicked = new Subject<boolean>(false);
	private banReason = new Subject<string>(
		'Нарушение правил дорожного движения, оскорбление чувств Артема Бахии и не любовь к BMW!',
	);
	private kickReason = new Subject<string>(
		'Нарушение правил дорожного движения, оскорбление чувств Артема Бахии и не любовь к BMW!',
	);
	private banExpiresAt = new Subject<number | null>(
		Date.now() + 2 * 24 * 60 * 60 * 1000,
	);

	constructor() {
		(global as any).setMute = (minutes: number | null) => {
			this.muteExpiresAt.next(
				minutes === null ? null : Date.now() + minutes * 60 * 1000,
			);
		};
	}

	public getMuteExpiresAt(): IObservable<number | null> {
		return this.muteExpiresAt;
	}

	public isPlayerBanned(): IObservable<boolean> {
		return this.playerBanned;
	}

	public isPlayerKicked(): IObservable<boolean> {
		return this.playerKicked;
	}

	public getBanReason(): IObservable<string> {
		return this.banReason;
	}

	public getKickReason(): IObservable<string> {
		return this.kickReason;
	}

	public getBanExpiresAt(): IObservable<number | null> {
		return this.banExpiresAt;
	}
}
